import {
  darkBgMeridianLogoImage,
  davidLloydLogoImage,
  harbourLogoImage,
  whiteHarbourLogoImage,
} from 'src/helpers/fixed-images/logo-images';

import { BuildType } from '../../enums/build/build-type';

export type Logos = {
  headerLogo: Queries.ImageDetails;
  whiteBackgroundLogo: Queries.ImageDetails;
};

export const getLogos = (buildType: BuildType): Logos => {
  switch (buildType) {
    case BuildType.HARBOUR:
      return {
        headerLogo: whiteHarbourLogoImage,
        whiteBackgroundLogo: harbourLogoImage,
      };
    case BuildType.MERIDIAN:
      return {
        headerLogo: darkBgMeridianLogoImage,
        whiteBackgroundLogo: darkBgMeridianLogoImage,
      };
    default:
      return {
        headerLogo: davidLloydLogoImage,
        whiteBackgroundLogo: davidLloydLogoImage,
      };
  }
};
